import momentumlogo from "../assets/images/Momentum Logo (2).png";
import momentumsmalllogo from "../assets/images/MSmallLogo.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HistoryLandingPage from "../History/HistoryLandingPage";
import closeIcon from "../assets/images/close (1).svg";
import UserGuide from "../assets/images/UserGuide.png";
import calllog from "../assets/images/calllog.png";
import document from "../assets/images/document.png";
import bookmark from "../assets/images/bookmark.png";
import chats from "../assets/images/chat.png";
import logout from "../assets/images/logout.png";
import hamburger from "../assets/images/hamburger.png";
import webinars from "../assets/images/webinars.png";
import folder from "../assets/images/folder.png";
import Help from "../assets/images/Help.png";
import Link from "../assets/images/link.png";
import history from "../assets/images/history.svg";
import notebookicon from "../assets/images/notebooklogo.svg";
import users from "../assets/images/user.png";
import department from "../assets/images/department.png";
import office from "../assets/images/office.png";
import admin from "../assets/images/admin.png";
import { useAppLogout } from "./useAppLogout";
import { Dropdown } from "primereact/dropdown";


export default function Sidebar(props: any) {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const navigate = useNavigate();
  const [showHistory, setShowHistory] = useState(false);
  const [showDocSubMenu, setShowDocSubMenu] = useState(false);
  const [showCompanyDSubMenu, setShowCompanyDSubMenu] = useState(false);
  const [historySearch, setHistorySearch] = useState("");
  const [selectedType, setSelectedType] = useState("Support");
  const appLogout = useAppLogout();

  const onHamburgerClick = () => {
    setShowWideSidebar(!showWideSidebar);
    props.onSidebarValueChanged(!showWideSidebar);
  };
  const onChatClick = () => {
    window.location.href = "/chat";
  };

  const onSavedChatsClick = () => {
    navigate("/saved");
  };
  const onDocumentsClick = () => {
    navigate("/documents");
    setShowDocSubMenu(true);
  };
  const onSupportCallAnalysisClick = () => {
    navigate("/supportcall");
  };
  const onHistoryClick = () => {
    // navigate("/history");
    setShowHistory(true);
  };
  const onHistoryClose = () => {
    setShowHistory(false);
  };
  const onDashboardClick = () => {
    navigate("/dashboard");
  };
  const onResearchClick = () => {
    navigate("/research");
  };
  const onLogoutClick = () => {
    // appLogout(navigate);
    localStorage.clear();
    navigate("/");
  };
  const onLogoClick = () => {
    navigate("/chat");
  }
  const onGuideClick = () => {
    navigate("/guide");
  };
  const onWebinarClick = () => {
    navigate("/webinar")
  }
  const onOS165Click = () => {
    navigate("/os165");
    setShowDocSubMenu(true);
  };
  const onMUniversityClick = () => {
    window.open("https://university.nowcerts.com/", "_blank");
    setShowDocSubMenu(true);
  };
  const onSupportClick = () => {
    window.open("https://support.momentumamp.com/", "_blank");
    setShowDocSubMenu(true);
  };
  const onLinksClick = () => {
    navigate("/links");
    setShowDocSubMenu(true);
  };
  const onNotebookClick = () => {
    navigate("/notebooklm");
    setShowDocSubMenu(true);
  };
  const onCompanyDirectoryClick = () => {
    navigate("/companydirectory");
    setShowCompanyDSubMenu(true);
  };
  const onEmployeeClick = () => {
    navigate("/employee");
    setShowCompanyDSubMenu(true);
  };
  const onDepartmentClick = () => {
    navigate("/department");
    setShowCompanyDSubMenu(true);
  };
  const onOfficeClick = () => {
    navigate("/office");
    setShowCompanyDSubMenu(true);
  };
  const onAdminClick = () => {
    navigate("/admin");
    setShowCompanyDSubMenu(true);
  };

  const typeOptions = [
  { label: "Support", value: "Support" },
  { label: "Call", value: "Call" },
];

return (
  <>
    <div
      className="position-fixed start-0 bg-white border-end p-0 text-14 sidebar"
      style={{
        width: showWideSidebar ? "250px" : "50px",
        transition: "width 0.4s ease",
        minWidth: showWideSidebar ? "250px" : "50px",
        height: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <div className="text-center my-5">
          <img src={showWideSidebar ? momentumlogo : momentumsmalllogo} alt="Logo" height={35} onClick={onLogoClick} />
        </div>
        <div className={`d-flex align-items-center border-top border-bottom py-2 ${!showWideSidebar ? "justify-content-center" : "px-4"}`}>
          <img src={hamburger} alt="Logo" className="show-cursor" onClick={onHamburgerClick} width={24} style={{ filter: 'brightness(100%) contrast(30%)' }} />
        </div>
      </div>
      <div style={{ 
        overflowY: "auto", 
        flex: 1,
        display: "flex",
        flexDirection: "column"
      }}>
        <div style={{ flex: 1 }}>
          <h6 className={`text-uppercase text-muted mt-2 d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : "px-3"}`}>
            Chat
          </h6>
          <ul className={`nav flex-column mb-3 ${showWideSidebar ? "px-2" : "px-0"}`}>
            <li className={`nav-item ${props.pagename == "chat" ? "active" : " "}`} onClick={onChatClick}>
              <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={chats} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Chat</span>}
              </a>
            </li>

            <li className={`nav-item ${props.pagename == "history" ? "active" : " "}`} onClick={onHistoryClick}>
              <a href="#" className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={history} alt="Logo" className="sideicon" width={24} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">History</span>}
              </a>
            </li>
            <li className={`nav-item ${props.pagename == "savedchats" ? "active" : " "}`} onClick={onSavedChatsClick}>
              <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={bookmark} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Bookmarks</span>}
              </a>
            </li>
          </ul>
          
          <h6 className={`text-uppercase text-muted d-flex align-items-center border-top py-2 ${!showWideSidebar ? "justify-content-center" : "px-3"}`}>
            Main
          </h6>
          <ul className={`nav flex-column mb-3 ${showWideSidebar ? "px-2" : "px-0"}`}>
            <li className={`nav-item ${["documents", "os165", "m-university", "support/help", "links", "notebooklm"].includes(props.pagename) ? "active" : ""}`}>
              <a onClick={onDocumentsClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`} style={{ cursor: "pointer" }}>
                <img src={document} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Documents</span>}
              </a>
              {(showDocSubMenu || ["documents", "os165", "m-university", "support/help", "links", "notebooklm"].includes(props.pagename)) && showWideSidebar && (
                <li className="doc-submenu ps-4 mt-2 documents-submenu">
                  <li className={`subnav-item ${props.pagename === "os165" ? "active" : ""}`}>
                    <a onClick={onOS165Click} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={folder} alt="OS 165" className="sub-sideicon" width={20} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">OS 165</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "m-university" ? "active" : ""}`}>
                    <a onClick={onMUniversityClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={momentumsmalllogo} alt="Momentum University" className="sub-sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Momentum University</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "support/help" ? "active" : ""}`}>
                    <a onClick={onSupportClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={Help} alt="Support/Help" className="sub-sideicon" width={21} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Support/Help</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "links" ? "active" : ""}`}>
                    <a onClick={onLinksClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={Link} alt="IMP Links" className="sub-sideicon" width={20} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">IMP Links</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "notebooklm" ? "active" : ""}`}>
                    <a onClick={onNotebookClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={notebookicon} alt="IMP Links" className="" width={20} />
                      <span className="ms-2">Notebook LM</span>
                    </a>
                  </li>
                </li>
              )}
            </li>
            <li className={`nav-item ${props.pagename == "supportcall" ? "active" : " "}`} onClick={onSupportCallAnalysisClick}>
              <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={calllog} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Calls Log</span>}
              </a>
            </li>
            <li className={`nav-item ${props.pagename == "webinar" ? "active" : " "}`} onClick={onWebinarClick}>
              <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={webinars} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Webinar</span>}
              </a>
            </li>
            {/* <li className={`nav-item ${["companydirectory", "office", "", "employee", "department", "admin"].includes(props.pagename) ? "active" : ""}`}>
              <a onClick={onCompanyDirectoryClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`} style={{ cursor: "pointer" }}>
                <img src={momentumsmalllogo} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">Company Directory</span>}
              </a>
              {(showCompanyDSubMenu || ["companydirectory", "office", "employee", "department", "admin", ""].includes(props.pagename)) && showWideSidebar && (
                <li className="companydirectory-submenu ps-4 mt-2 company-submenu">
                  <li className={`subnav-item ${props.pagename === "employee" ? "active" : ""}`}>
                    <a onClick={onEmployeeClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={users} alt="OS 165" className="sub-sideicon" width={20} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Employees</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "department" ? "active" : ""}`}>
                    <a onClick={onDepartmentClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={department} alt="Momentum University" className="sub-sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Departments</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "office" ? "active" : ""}`}>
                    <a onClick={onOfficeClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={office} alt="Support/Help" className="sub-sideicon" width={21} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Offices</span>
                    </a>
                  </li>
                  <li className={`subnav-item ${props.pagename === "admin" ? "active" : ""}`}>
                    <a onClick={onAdminClick} className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                      <img src={admin} alt="IMP Links" className="sub-sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                      <span className="ms-2">Admin</span>
                    </a>
                  </li>
                </li>
              )}
            </li> */}
            <li className={`nav-item ${props.pagename == "guide" ? "active" : " "}`} onClick={onGuideClick}>
              <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
                <img src={UserGuide} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
                {showWideSidebar && <span className="ms-2">User Guide</span>}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div style={{ 
        flexShrink: 0, 
        borderTop: "1px solid #dee2e6",
        backgroundColor: "#fff"
      }}>
        <ul className={`nav flex-column ${showWideSidebar ? "px-2" : "px-0"}`}>
          <li className={`nav-item logout-btn ${props.pagename == "logout" ? "active" : ""}`} onClick={onLogoutClick}>
            <a className={`nav-link d-flex align-items-center ${!showWideSidebar ? "justify-content-center" : ""} text-dark`}>
              <img src={logout} alt="Logo" className="sideicon" width={22} style={{ filter: 'brightness(100%) contrast(30%)' }} />
              {showWideSidebar && <span className="ms-2">Logout</span>}
            </a>
          </li>
        </ul>
      </div>
    </div>

    {showHistory ? (
      <div
        className="history-sidebar"
        style={{ left: showWideSidebar ? "250px" : "50px" }}
      >
        <div className="history-sidebar-header">
          <span>Recent Conversation</span>
          <img
            src={closeIcon}
            alt="Close"
            title="Close"
            className="history-sidebar-close-icon"
            onClick={onHistoryClose}
          />
        </div>

        <div className="history-sidebar-search-wrapper">
          <input
            type="text"
            className="form-control-sm custom-inputbox custom-input"
            placeholder="Search history..."
            value={historySearch}
            onChange={(e) => setHistorySearch(e.target.value)}
          />
        </div>

        <div className="history-sidebar-dropdown-wrapper">
          <Dropdown
            value={selectedType}
            options={typeOptions}
            onChange={(e) => setSelectedType(e.value)}
            className="small-dropdown w-100"
            placeholder="Select Type"
          />
        </div>

        <div style={{ overflowY: "auto", flex: 1, padding: "1rem" }}>
          <HistoryLandingPage searchTerm={historySearch} selectedType={selectedType} />
        </div>
      </div>
    ) : null}
  </>
);

}